import { selectCurrentChannel, selectActiveChannel, selectLayoutCellById } from '../store/selectors';
import { RootState } from '../store/reducers/persistedReducer';
import { ROUTE_ACTIONS } from '../store/routes';

export default (store: any) => {

  let prevTitle: string;

  const setTitle = () => {
    const state: RootState = store.getState();

    // Set default title
    const DEFAULT = "ClusterX";
    let title= DEFAULT;

    // Append to default title based on criteria
    switch (state.location.type) {
      case ROUTE_ACTIONS.HOME:
        break;
      case ROUTE_ACTIONS.CHANNEL:
        const { centroidId, familyTag } = selectActiveChannel(state);
        const channel = selectCurrentChannel(state);

        if (channel) {
          let channelTitle = " - " + channel.name;

          if (centroidId) {
            const centroid = selectLayoutCellById(state, centroidId);

            if (centroid) {
              channelTitle += " (" + centroid.title + ")"
            }
          }

          if (familyTag) {
            channelTitle += " (" + familyTag + ")"
          }
          title += channelTitle
        }
        break;
      case ROUTE_ACTIONS.LOGIN:
        title += " - Login";
        break;
      default:
    }

    if (title !== prevTitle) {
      document.title = prevTitle = title;
    }
  }

  store.subscribe(setTitle);
}